import { HANDLE_USER, RESET } from '../actions';

const initialState = {
    userList: [],
    userCopy: [],
    search: "",
    vehicleFilter: "",
    roleFilter: ""
};

const UserDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_USER:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default UserDetails;